interface SectionHeaderProps {
  eyebrow?: string
  title: string
  description?: string
  align?: 'left' | 'center'
  className?: string
}

export default function SectionHeader({ 
  eyebrow, 
  title, 
  description, 
  align = 'left',
  className = '' 
}: SectionHeaderProps) {
  const alignmentClasses = align === 'center' ? 'text-center items-center' : 'text-left items-start'
  
  return (
    <div className={`flex flex-col gap-4 ${alignmentClasses} ${className}`}>
      {eyebrow && (
        <span className="text-micro uppercase tracking-ultra-wide text-primary font-medium">
          {eyebrow}
        </span>
      )}
      <h2 className="text-h2 text-white">
        {title}
      </h2>
      {description && (
        <p className="text-body-sm text-gray-300 max-w-prose">
          {description}
        </p>
      )}
    </div>
  )
}